export default {
    title: 'Adapt management rights',
    label: 'No person selected|1 person selected|{cnt} Persons selected',
    description: 'Select the people who should be given administration rights for the trend radar. Note: The admin of your company can manage all trend radars',
    button: {
        submit: 'Submit'
    },
    tooltip: 'End customize management rights'
}
